import type { App } from 'vue'
import { ActionSheet, Button, ConfigProvider, Divider, Icon, Loading } from 'vant'

import { Tab, Tabs } from 'vant'
import { NavBar } from 'vant'
import { Popup } from 'vant'
import 'vant/lib/index.css'

export const VantPlugin = {
  install(app: App<Element>) {
    app.use(ActionSheet)
    app.use(Button)
    app.use(Tab)
    app.use(Tabs)
    app.use(NavBar)
    app.use(Popup)
    app.use(Loading)
    app.use(NavBar)
    app.use(Icon)
    app.use(Divider)
    app.use(ConfigProvider)
  },
}
